import { Component, Input } from '@angular/core';
import { I18NDescriptor } from '../uikit.interface';

export interface GaGoalData {
  name: string;
  completions: number;
}

export interface GoalTableHeaderConfig {
  title: I18NDescriptor;
  subtitle?: I18NDescriptor;
}

export interface GoalTableColumnConfig {
  headingColumnTitle?: I18NDescriptor;
  columnTitle?: I18NDescriptor;
}

export interface GoalTableConfig {
  header: GoalTableHeaderConfig;
  column: GoalTableColumnConfig;
}

export interface LocationConfig {
  locationCount?: number;
  message?: I18NDescriptor;
}

export interface DataSourceConfig {
  sourceUrl: string;
  sourceIconUrl?: string;
  sourceTooltip?: string;
  floatingLink?: boolean;
  poweredByI18NDescriptor?: I18NDescriptor;
  poweredBy: string;
}

export interface FooterConfig {
  locationConfig?: LocationConfig;
  dataSourceConfig?: DataSourceConfig;
}

@Component({
  selector: 'va-goal-table',
  templateUrl: 'goal-table.component.html',
  styleUrls: ['goal-table.component.scss'],
})
export class VaGoalTableComponent {
  @Input() dataSource: GaGoalData[];
  @Input() tableConfig: GoalTableConfig;
  @Input() footerConfig: FooterConfig;

  displayedColumns = ['goalName', 'completions'];
}
